import { ILightRailItemImage } from '../../../types'
import {
  EpisodeListItemNowPlaying,
  EpisodeListItemThumbnail,
} from './EpisodeListItem.style'
import { he } from '../../../locales/he'
import { useMemo, useState } from 'react'

export const EpisodeListItemThumbnailComp = ({
  images,
  name,
  nowPlaying,
  isClip,
  bigImage,
}: {
  images: ILightRailItemImage[]
  name: string
  nowPlaying: boolean
  isClip?: boolean
  bigImage?: boolean | undefined
}) => {
  const [imageLoaded, setImageLoaded] = useState(false)
  const [image, setImage] = useState({
    default: true,
    url: 'https://media3.reshet.tv/image/upload/v1709542182/ott/400x400_Logo_Clear_1.webp',
    error: false,
  })
  useMemo(() => {
    if (images.length > 0) {
      setImage({
        error: false,
        default: false,
        url: images[0].url + '/width/320/height/' + (320 * 9) / 16,
      })
    }
  }, [images])

  return (
    <EpisodeListItemThumbnail
      theme={{
        useDefault: image.default,
        loaded: imageLoaded,
        error: image.error,
        isClip: isClip,
        bigImage: !!bigImage,
      }}
    >
      {image.url && (
        <img
          loading='lazy'
          src={image.url}
          alt={name}
          onError={() => {
            setImageLoaded(true)
            setImage({
              ...image,
              error: true,

              url: 'https://media3.reshet.tv/image/upload/v1709542182/ott/400x400_Logo_Clear_1.webp',
            })
          }}
        />
      )}
      {nowPlaying && (
        <EpisodeListItemNowPlaying>
          {he.nowPlayingOtt}
        </EpisodeListItemNowPlaying>
      )}
    </EpisodeListItemThumbnail>
  )
}
